import { useTranslation } from 'react-i18next'
import { TERMS_LINK, POLICY_LINK, COOKIE_POLICY_LINK } from '@constants'
import { Logo } from '../Logo'
import { LanguageSelect } from './LanguageSelect'
import * as S from './styled'

const year = new Date().getFullYear()

export function Footer() {
  const { t } = useTranslation()

  return (
    <S.Footer>
      <Logo style={{ fontSize: 35, paddingBlock: 2 }} />
      <S.Legal>{t('legal_text')}</S.Legal>
      <S.DesktopBlock>
        <S.LegalRow>
          <S.FooterLinks>
            <S.FooterLink href={TERMS_LINK} target={'_blank'}>
              {t('terms_of_use')}
            </S.FooterLink>
            <S.FooterLink href={POLICY_LINK} target={'_blank'}>
              {t('privacy_policy')}
            </S.FooterLink>
            <S.FooterLink href={COOKIE_POLICY_LINK} target={'_blank'}>
              {t('cookie_policy')}
            </S.FooterLink>
          </S.FooterLinks>
          <S.Copyright>{t('copyright', { year })}</S.Copyright>
        </S.LegalRow>
        <LanguageSelect />
      </S.DesktopBlock>
    </S.Footer>
  )
}
